// Enrutamiento por hash, sin librerías: #/inicio, #/candidatos?vacante=v1&vista=tablero, #/candidato/k1, #/metricas, #/vacantes, #/cuenta
import { useMemo, useSyncExternalStore } from "react";

export type Pantalla = "inicio" | "candidatos" | "candidato" | "metricas" | "vacantes" | "cuenta";
export type Ruta = { pantalla: Pantalla; id: string | null; params: URLSearchParams };

const PANTALLAS: Pantalla[] = ["inicio", "candidatos", "candidato", "metricas", "vacantes", "cuenta"];

export function leerRuta(hash: string): Ruta {
  const limpio = hash.replace(/^#\/?/, "");
  const [camino, query = ""] = limpio.split("?");
  const [p, id] = camino.split("/").filter(Boolean);
  const pantalla = PANTALLAS.includes(p as Pantalla) ? (p as Pantalla) : "inicio";
  return { pantalla, id: pantalla === "candidato" ? (id ?? null) : null, params: new URLSearchParams(query) };
}

function suscribir(cb: () => void) {
  window.addEventListener("hashchange", cb);
  return () => window.removeEventListener("hashchange", cb);
}

export function useRuta(): Ruta {
  const hash = useSyncExternalStore(suscribir, () => window.location.hash);
  return useMemo(() => leerRuta(hash), [hash]);
}

/** Arma un hash: ruta("candidatos", {vacante: "v1"}) → "#/candidatos?vacante=v1" */
export function ruta(camino: string, params?: Record<string, string | null | undefined>): string {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params ?? {})) if (v) q.set(k, v);
  const s = q.toString();
  return `#/${camino}${s ? "?" + s : ""}`;
}

export function navegar(hash: string, reemplazar = false) {
  if (window.location.hash === hash) return;
  if (reemplazar) {
    const url = window.location.pathname + window.location.search + hash;
    window.history.replaceState(null, "", url);
    window.dispatchEvent(new HashChangeEvent("hashchange"));
  } else {
    window.location.hash = hash;
  }
}
